import domReady from '@wordpress/dom-ready';

/**
 * Handles the click event on a live entry link.
 *
 * @param {Event} event
 */
const liveEntryLinkClick = (event) => {
  event.preventDefault();
  const href = event.target.getAttribute('href');
  const id = href.replace('#entry:', '');
  const element = document.getElementById(`entry:${id}`);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

domReady(() => {
  document.querySelectorAll('.mediapress-live-entry-link').forEach((link) => {
    link.addEventListener('click', liveEntryLinkClick);
  });
});
